import { Percent, Coins, Article } from '@phosphor-icons/react';

const hasCommission = (p) =>
  Number(p.default_commission) > 0 || Object.values(p.commission_by_seller || {}).some(v => Number(v) > 0);

const CHECKS = [
  { key: 'commission', missing: (p) => !hasCommission(p), Icon: Percent, title: 'Falta comisión', cls: 'bg-violet-100 text-violet-700 border-violet-300' },
  { key: 'cost', missing: (p) => !(Number(p.purchase_cost) > 0), Icon: Coins, title: 'Falta costo', cls: 'bg-orange-100 text-orange-700 border-orange-300' },
  { key: 'description', missing: (p) => !(p.description || '').trim(), Icon: Article, title: 'Falta descripción', cls: 'bg-sky-100 text-sky-700 border-sky-300' },
];

export const MissingInfoBadges = ({ product }) => {
  const missing = CHECKS.filter(c => c.missing(product));
  if (!missing.length) return null;
  return (
    <div className="inline-flex gap-1" data-testid={`missing-info-${product.id}`}>
      {missing.map(({ key, Icon, title, cls }) => (
        <span key={key} title={title} className={`w-5 h-5 rounded-full border flex items-center justify-center ${cls}`}
          data-testid={`missing-${key}-${product.id}`}>
          <Icon size={11} weight="bold" />
        </span>
      ))}
    </div>
  );
};
